export const PARAM_KEY_SPEEDINGS_TAB = "speedingsTab"
export const PARAM_KEY_SPEEDINGS_YEAR = "speedingsYear"
export const PARAM_KEY_SPEEDINGS_ACTIVE_LAYER = "speedingsActiveLayer"
export const SPEEDINGS_DEFAULT_ACTIVE_LAYER = "speedings"
export const SPEEDINGS_LIGHT_VEHICLE_ACTIVE_LAYER = "lightVehicle"
export const SPEEDINGS_HEAVY_VEHICLE_ACTIVE_LAYER = "heavyVehicle"